import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from '../../../../services/device.service';
import { MomentPipe } from 'app/pipes/pipes';
import { Device } from 'app/models/device.model';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'display-device-info',
    imports: [
        CommonModule,
        TranslateModule,
        MomentPipe,
        MatTooltipModule
    ],
    templateUrl: './display-device-info.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./display-device-info.component.css']
})
export class DisplayDeviceInfo implements OnInit {
  constructor(
    private deviceService: DeviceService
  ) { }

  @Input() device: Device;
  @Input() userRoleLevel: number;
  @Input() residentsLength: number;
  @Output() enterEditMode = new EventEmitter<any>();

  iotCommsEnabled: boolean;

  ngOnInit(){
    this.iotCommsEnabled = this.deviceService.featureEnabled("IotComms")
  }

  onEditMode(){
    this.enterEditMode.emit();
  }

  isLock(): boolean {
    return this.deviceService.isLock(this.device.deviceType);
  }
}
